import React, { useState, useEffect } from "react";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { formatCmsHtml } from "../../utils/formatCmsHtml";
import "./PolicyPages.css";

const PrivacyPolicy = () => {
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const fetchPrivacyPolicy = async () => {
            try {
                const response = await service.get(
                    endpoints.cms.privacyPolicy,
                    {},
                    { headers: { Authorization: undefined } }
                );

                if (response?.data?.success) {
                    setContent(response?.data?.data || "");
                } else {
                    setErrorMessage(
                        response?.data?.message ||
                        "Unable to fetch privacy policy content."
                    );
                }
            } catch (error) {
                console.error("Privacy Policy API error:", error);
                setErrorMessage(
                    error?.response?.data?.message ||
                    "An error occurred while loading content."
                );
            } finally {
                setLoading(false);
            }
        };

        fetchPrivacyPolicy();
    }, []);

    if (loading) {
        return (
            <div className="view-policy-wrapper">
                <div className="policy-loading-container">
                    <div className="policy-loader" />
                    <p>Loading, please wait...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="view-policy-wrapper">
            <div className="view-policy-container">
                <div className="privacy-policy-heading mb-4">
                    <h4>Privacy Policy</h4>
                </div>

                <div className="view-policy-content">
                    {errorMessage ? (
                        <div className="policy-error-container">
                            <p>{errorMessage}</p>
                        </div>
                    ) : content ? (
                        <div
                            className="policy-body"
                            dangerouslySetInnerHTML={{
                                __html: formatCmsHtml(content),
                            }}
                        />
                    ) : (
                        <div className="policy-error-container">
                            <p>No content available.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
